import React from "react";
import { createRoot } from "react-dom/client";
import { ChakraProvider, Box } from "@chakra-ui/react";
import App from "./App";
import "./index.css";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <React.StrictMode>
    <ChakraProvider>
      <Box
        h="100vh"
        // bgGradient="linear(to-r, #1b193e, blue.600)"
        // color="white"
        bg={"#f6f6f6b3"}
      >
        <App />
      </Box>
    </ChakraProvider>
  </React.StrictMode>
);
